import { render } from "./TheHomeMain.vue?vue&type=template&id=1a723175"
import script from "./TheHomeMain.vue?vue&type=script&lang=js"
export * from "./TheHomeMain.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__